import React, { useEffect, useState } from "react";
import Style from './UserInfo.module.css';
import Button from '../../../components/controls/button/Button'
import Input from '../../../components/controls/input/customInput/CustomInput'
import Modal from '../../../components/controls/modal/Modal'
import DropDown from "../../../components/controls/dropdown/DropdownFluent";
import RolesSetup from "../../../components/controls/roles/Roles";
// import Avatar from '../../../components/controls/avatar/Avatar';
import PhoneInput from "../../../components/controls/input/phoneInput/PhoneInput";
import { checkEmail } from "../../../utils/formValidation";
import { timezones } from '../../../helpers/utils';
import { Avatar } from "@fluentui/react-components";
import {
    makeStyles,
    partitionAvatarGroupItems,
  } from "@fluentui/react-components";
import UploadLogo from "../../../views/settings/UploadLogo";
  const useStyles = makeStyles({
    root: {
      display: "grid",
      flexDirection: "column",
      rowGap: "10px",
    },
  });
  
  const names = [
    "Johnie McConnell",
    "Allan Munger",
    "Erik Nason",
    "Kristin Patterson",
    "Daisy Phillips",
    "Carole Poland",
    "Carlos Slattery",
    "Robert Tolbert",
    "Kevin Sturgis",
    "Charlotte Waltson",
    "Elliot Woodward",
  ];

const UserInfo = (props) => {
    const partitionedItems = partitionAvatarGroupItems({ items: names });
    const piePartitionedItems = partitionAvatarGroupItems({
        items: names,
        layout: "pie",
    });
    const {
        user,
        error,
        infoLoading,
        pictureLoading,
        updateProfileData,
        updateProfilePicture,
    } = props;
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [firstName, setFirstName] = useState(user.firstName || '');
    const [lastName, setLastName] = useState(user.lastName || '');
    const [email, setEmail] = useState(user.email || '');
    const [phoneNumber, setPhone] = useState(user.phoneNumber || '');
    const [userInfo, setUserInfo] = useState(user);
    const [emailError, setEmailError] = useState('');
    const [timezone, setTimezone] = useState(user.timezone || '');
    const [formErrors, setFormErrors] = useState({
        email: '',
        firstName: '',
        lastName: '',
    });

    const handleSave = () => {
        const errors = {};
        if (!firstName) errors['firstName'] = `The FirstName field is required.`;
        if (!lastName) errors['lastName'] = `The LastName field is required.`;
        if (!email) errors['email'] = `The Email field is required.`;
        setFormErrors(errors);
        if (Object.keys(errors).length) {
            return;
        }
        const payload = {
            id: userInfo.id,
            userName: userInfo.userName,
            firstName: firstName,
            lastName: lastName,
            email: email,
            phoneNumber: phoneNumber,
            roles: userInfo.roles && userInfo.roles.map(r => r.id),
            isActive: true,
            timezone: timezone
        }
        if(emailError !== '') return;
        
        updateProfileData(payload);
    }

    const handleInputChange = (value, name) => {
        if (name === 'firstName') setFirstName(value);
        if (name === 'lastName') setLastName(value);
        if (name === 'email') setEmail(value);
    }

    const getRole = () => {
        if (userInfo.roles) {
            const roles = userInfo.roles.map((role) => role.name)
            return roles.join(', ');
        }
        return '';
    }
    
    useEffect(() => {
        if (!pictureLoading) {
            setShowUploadModal(false);
        }
    }, [pictureLoading])

    const isAnyInputSet = () => {
        return email !== '' || 
            firstName !== '' ||
            lastName !== '' ||
            phoneNumber !== '';
    };

    const validateEmail = (event) => {
        const error = checkEmail(event.target.value);
        if(error) {
            setEmailError(error)
        } else {
            setEmailError('')
        }
    }

    useEffect(() => {
        setUserInfo(user);
    }, [user])

    useEffect(() => {
        if(error !== "") {
            setFormErrors({});
            Object.keys(error).forEach((key) => {
                if (key === 'FirstName') {
                    setFormErrors((prevErrors) => ({
                      ...prevErrors,
                      firstName: error[key][0]
                    }));
                }
                if (key === 'LastName') {
                    setFormErrors((prevErrors) => ({
                      ...prevErrors,
                      lastName: error[key][0]
                    }));
                }
                if (key === 'Email') {
                    setFormErrors((prevErrors) => ({
                      ...prevErrors,
                      email: error[key][0]
                    }));
                }
                if (key === 'code') {
                    setFormErrors((prevErrors) => ({
                      ...prevErrors,
                      email: error.message
                    }));
                }
            });
        } else {
            setFormErrors({});
        }
    }, [error])
    
    return (
        <>
            <div className= {`${Style.mainWrapper} font-family-imp height-adjust`}>
                <p className={Style.infoLabel}>Your info</p>
                <div className={Style.profileContainer}>
                    <p className={Style.profileLabel}>Profile</p>
                    <div className={Style.userInfoWrapper}>
                        {userInfo.profilePictureUrl !== null ?
                            <img src={userInfo.profilePictureUrl} alt="" />
                            :
                            <Avatar name={userInfo.fullName} cssClass={Style.avatar} />
                        }
                        <div>
                            <p className={Style.userName}>{userInfo.userName}</p>
                            <p className={Style.userProfile} onClick={() => setShowUploadModal(true)}>Upload a new picture</p>
                        </div>
                    </div>
                    <div className="w-100">
                        <div className="d-flex align-items-start w-100">
                            <Input
                             inputwd="w-50 me-3"
                                icon={false}
                                placeholder="Enter first name"
                                value={firstName}
                                type="text"     
                                handleChange={(value) => handleInputChange(value, 'firstName')}
                                label="First name"
                                errorMessage={formErrors.firstName}
                            />
                            <Input
                            inputwd="w-50"
                                icon={false}
                                placeholder="Enter last name"
                                value={lastName}
                                type="text"
                                handleChange={(value) => handleInputChange(value, 'lastName')}
                                label="Last name"
                                errorMessage={formErrors.lastName}
                            />
                        </div>
                        <div className="d-flex justify-content-between align-items-center mt-3">
                            <Input
                                inputwd="w-50 me-3"
                                icon={false}
                                placeholder="Enter email"
                                value={email}
                                type="email"
                                handleChange={(value) => handleInputChange(value, 'email')}
                                handleBlur={validateEmail}
                                label="Email"
                                errorMessage={emailError || formErrors.email}
                            />
                            <div className="w-50">
                            <PhoneInput label="Phone Number" value={userInfo.phoneNumber} handleChange={setPhone} placeholder="Enter phone number" />
                            </div> 
                        </div>
                        <div className="d-flex justify-content-between align-items-center mt-3">
                            <DropDown dropDownwd="w-50" label="Time Zone" options={timezones} defaultVal={timezone} onChange={setTimezone} /> 
                        </div>
                    </div>
                    <div className={Style.btnWrapper}>
                        <Button btnClass="d_btn d_btn_primary font-family-imp text-sm-400" cssClass={Style.btnSave} label="Save" clickHandler={handleSave} showLoading={infoLoading} />
                        {/* <Button btnClass="d_btn d_btn_primary font-family-imp text-sm-400" cssClass={Style.btnSave} label="Save" clickHandler={handleSave} isDisabled={!isAnyInputSet()} showLoading={infoLoading} /> */}
                    </div>
                </div>
                <div className={Style.rolesContainer}>
                    <p className={`${Style.infoLabel} mb-0`}>Roles</p>
                    <div className={Style.rolesWrapper}>
                        {/* <img src={Person} alt="" /> */}
                        <Avatar size={32}
                            
                        />
                        <p className="mb-0 ms-12">{userInfo && getRole()}</p>
                    </div>
                </div>
                {/* <div className={Style.groupsContainer}>
                    <p className={`${Style.infoLabel} mb-0`}>Groups</p>
                    <div className={Style.groupsWrapper}>
                        <img src={AvatarStack} alt="" />
                        <AvatarGroup layout="stack">
                        {partitionedItems.inlineItems.map((name) => (
                        <AvatarGroupItem name={name} key={name} />
                        ))}
                        {partitionedItems.overflowItems && (
                        <AvatarGroupPopover>
                            {partitionedItems.overflowItems.map((name) => (
                            <AvatarGroupItem name={name} key={name} />
                            ))}
                        </AvatarGroupPopover>
                        )}
                    </AvatarGroup>
                    </div>
                </div> */}
            </div>
            {showUploadModal && 
                <UploadLogo 
                    displayImage={userInfo.profilePictureUrl}
                    handleCancel={() => setShowUploadModal(false)}
                    uploadImage={updateProfilePicture}
                    showLoading={pictureLoading}
                />
            }
        </>
    );
}

export default UserInfo;